"use strict";
/**
 * 调起收银台
 *
 * ### Example
 * ```
 * openCashier({
 *     app: 'group',
 *     token: 'xxx',
 *     tradeNo: 'xxx',
 *     payToken: 'xxx',
 *     version: '7.5.0',
 *     successURL: 'http://i.meituan.com'
 * });
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var object_to_query_1 = require("./object-to-query");
var compare_version_1 = require("./compare-version");
var cashierType;
var encode = encodeURIComponent;
function getCashierType(app, version) {
    switch (app) {
        case 'group':
            return compare_version_1.compareVersion(version, '6.4') === -1 ? 'imeituan' : 'meituanpayment';
        case 'movie':
        case 'waimai':
        case 'dianping-nova':
        case 'QCSC':
            return 'meituanpayment';
        case 'conch':
            return 'conch';
    }
    return 'web';
}
exports.getCashierType = getCashierType;
function web(conf) {
    var iCashierParams = conf.iCashierParams ? conf.iCashierParams : {};
    var params = tslib_1.__assign({ auth: 'v2', token: conf.token, tradeno: conf.tradeNo, redr_url: location.href, pay_token: conf.payToken, pay_success_url: conf.successURL }, iCashierParams);
    location.href = "https://npay.meituan.com/i/cashier/show/index?" + object_to_query_1.objectToQuery(params);
}
function conch(conf) {
    var url = encode("iconch://www.meituan.com/web?url=" + encode(conf.successURL));
    location.href = "meituanpayment://conchpay/launch?pay_token=" + conf.payToken + "&trans_id=" + conf.tradeNo + "&cashier_type=hello&nb_source=hellopay&callback_url=" + url + "&_knbopeninapp=1";
}
function sdk(conf) {
    var callback_url = (conf.successURL && conf.successURL.replace(/\s/g, '')) || '';
    if (callback_url) {
        var url = encode(cashierType + "://www.meituan.com/web?url=" + encode(callback_url));
        callback_url = "&callback_url=" + url;
    }
    var schemaUrl = cashierType + "://cashier/launch?pay_token=" + conf.payToken + "&trade_number=" + conf.tradeNo + callback_url + "&_knbopeninapp=1";
    if (conf.merchant_no) {
        schemaUrl += "&merchant_no=" + conf.merchant_no;
    }
    location.href = schemaUrl;
}
function openCashier(conf) {
    cashierType = getCashierType(conf.app, conf.version);
    switch (cashierType) {
        case 'web': return web(conf);
        case 'conch': return conch(conf);
        default: return sdk(conf);
    }
}
exports.openCashier = openCashier;
